<!--- FORMULARIO GESTIONAR PICKING EN MOVILIDAD  ---->
<!---
CASO DE USO: https://grupohispatec.sharepoint.com/:w:/s/Produccin/ET1C6fWOFaJJpt_tyMGjBgcBizW60BpPN3M4jv9UcXP5Ug?e=PzAEmr
Descripción del formulario:
---------------------------
- Formulario donde se permite gestionar los traspasos y los reprocesados en unidades logísticas.
--->
<template>
  <f7-page class="page-picking">
    <div class="menu">
      <PCSideNavbar
        show-more-button
        @item-clicked="OpcionSideNavbarSeleccionada"
      />
    </div>

    <div class="main-picking no-margin">
      <div>
        <!-- Search bar navigation
        <div class="content-header-activity-line">
          <div class="content-search-entity">
            <UCLineasDeProduccion
              :valor-por-defecto="defaultSelectLine"
              plantilla="P2"
              :mostrar-titulo="false"
              :deshabilitar-controles-de-avance-y-retroceso="countPendingCalls === 0 ? false : true"
              @lineaProduccionSeleccionada="EventProductionLineSelected"
            />
            End Search bar navigation
          </div>
          -->
      </div>
      <div>
        <!-- Center -->

        <div class="content-picking">
          <f7-row no-gap>
            <!------ PARTE LATERAL IZQUIERDA -->
            <f7-col width="45">
              <div class="content-picking__pedido">
                <div class="content-picking__pedido--grid">
                  <f7-button
                    :class="conPedido ? 'button-fill' : 'button-outline'"
                    color="steel-blue"
                    @click="EventConPedidoSelected"
                  >
                    {{ $t('commercialization.picking.labels.withOrder') }}
                  </f7-button>
                  <f7-button
                    :class="conPedido ? 'button-outline' : 'button-fill'"
                    color="steel-blue"
                    @click="EventSinPedidoSelected"
                  >
                    {{ $t('commercialization.picking.labels.withoutOrder') }}
                  </f7-button>
                </div>
              </div>
              <div v-if="!conPedido">
                <PCCantidadesReservadasSinPedido
                  :new-data-transfer="newDataTransfer"
                  @manage-reservation="EventManageReservation"
                  @confirmation="EventConfiramtionNada"
                  @cancel="CancelEditReservationOrderLine"
                  @edit-pale="EventEditPale"
                  @component-state-change="PCGestionReservasComponentStateChanges"
                />
              </div>
              <div v-else>
                <PCSeleccionLineasPedidoVenta
                  ref="PCSeleccionLineasPedidoVenta"
                  :class="{ 'disabled-component': selectedOrderLine != null && enableManageReservation || PCGestionReservasComponentState !== 0 }"
                  @order-line-selection="EventOrderLineSelection"
                  @reset-reservation="EventResetResvations"
                />
              </div>
            </f7-col>
            <f7-col
              width="55"
              class="content-picking__right-side"
            >
              <div v-if="conPedido">
                <PCGestionReservas
                  ref="PCGestionReservas"
                  :class="{ 'disabled-component': selectedOrderLine != null && enableManageReservation }"
                  :order-line="selectedOrderLine"
                  :new-data-transfer="newDataTransfer"
                  @manage-reservation="EventManageReservation"
                  @confirmation="EventConfiramtionNada"
                  @cancel="CancelEditReservationOrderLine"
                  @edit-pale="EventEditPale"
                  @component-state-change="PCGestionReservasComponentStateChanges"
                />
              </div>
<!--      v-show="selectedOrderLine != null && enableManageReservation"

-->               <PCGestionPaletizado
                  :selected-order-line="selectedOrderLine"
                  :select-manage-reservation="enableManageReservation"
                  :selected-edit-pale="selectedEditPale"
                  :con-pedido="conPedido"
                  @confirmation="EventConfiramtionOussama"
                  @cancellation="EventCancellationOussama"
                />
            </f7-col>
          </f7-row>
        </div>
      </div>
    </div>

    <PCConfiguracionPicking
      v-model:opened="popupConfiguracionPicking"
    />
  </f7-page>
</template>

<script>
import { useSettingRef } from '@erpagroapp/settings';
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
// import UCLineasDeProduccion from '@/components/UCLineasDeProduccion.vue';
import PCGestionReservas from '@/components/production/commercialization/picking/PCGestionReservas.vue';
import PCSeleccionLineasPedidoVenta from '@/components/production/commercialization/picking/PCSeleccionLineasPedidoVenta.vue';
import PCGestionPaletizado from '@/components/production/commercialization/picking/PCGestionPaletizado.vue';
import { ComponentState } from '@/js/common/enum';
import PCCantidadesReservadasSinPedido from '@/components/production/commercialization/picking/PCCantidadesReservadasSinPedido.vue';
import PCConfiguracionPicking from '@/components/production/commercialization/picking/PCConfiguracionPicking.vue';
import PCSideNavbar from '@/components/common/PCSideNavbar.vue';

/** @import { SideNavbarItem } from '@/composables/useSideNavbar' */

export default {
  name: 'FrmPicking',
  components: {
    PCSideNavbar,
    PCGestionReservas,
    PCSeleccionLineasPedidoVenta,
    PCGestionPaletizado,
    PCCantidadesReservadasSinPedido,
    PCConfiguracionPicking,
  },

  data() {
    return {
      logoClient: null,
      selectedOrderLine: null, // Linea pedido venta seleccionada
      defaultLogo: null, // Logo por defecto
      enableManageReservation: false,
      newDataTransfer: [], // Ultima mercancía añadida para traspasar
      selectedEditPale: null, // pale en edición
      PCGestionReservasComponentState: 0, // Estado del componente, valores del enumerado ComponentState []
      conPedido: true, // varible para controlar si se trabaja con un pedido o sin un pedido
      popupConfiguracionPicking: false, // Abre la configuracion de Picking
      activarLecturaDeCajas: false, // habilita la opcion de menú de lectura de cajas
      logoApp: useSettingRef('App.Logo'),
    };
  },

  mounted() {
    this.StartForm();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      this.logoClient = this.GetLogo();
      this.PCGestionReservasComponentState = ComponentState.INITIAL;
    },

    GetLogo() {
      return this.logoApp || this.defaultLogo;
    }, /*
    EventProductionLineSelected(val) {
      Log(this, this.EventProductionLineSelected.name);
    },
    */
    EventManageReservation() {
      Log(this, this.EventManageReservation.name);
      this.enableManageReservation = true;
    },
    EventConfiramtionNada() {
      Log(this, this.EventConfiramtionNada.name);
      this.enableManageReservation = false;
      this.newDataTransfer = [];
    },
    EventOrderLineSelection(value) {
      Log(this, this.EventOrderLineSelection.name);
      this.selectedOrderLine = value;
      this.enableManageReservation = false;
    },
    EventResetResvations() {
      Log(this, this.EventResetResvations.name);
      this.$refs.PCGestionReservas.ResetComponent();
    },
    EventEditPale(value) {
      Log(this, this.EventEditPale.name);
      this.enableManageReservation = false;
      this.selectedEditPale = value;
    },
    EventConfiramtionOussama(value) {
      Log(this, this.EventConfiramtionOussama.name);
      const dataTranferTemp = [...this.newDataTransfer, value];
      this.enableManageReservation = false;
      this.selectedEditPale = null;
      this.newDataTransfer = dataTranferTemp;
    },
    EventCancellationOussama() {
      Log(this, this.EventCancellationOussama.name);
      this.enableManageReservation = false;
      this.selectedEditPale = null;
    },
    EventConPedidoSelected() {
      Log(this, this.EventConPedidoSelected.name);
      this.conPedido = true;
      this.enableManageReservation = false;
      this.selectedEditPale = null;
    },
    EventSinPedidoSelected() {
      Log(this, this.EventSinPedidoSelected.name);
      this.conPedido = false;
      this.selectedOrderLine = null;
    },
    PCGestionReservasComponentStateChanges(state) {
      Log(this, this.PCGestionReservasComponentStateChanges.name);
      this.PCGestionReservasComponentState = state;
    },
    CancelEditReservationOrderLine() {
      Log(this, this.CancelEditReservationOrderLine.name);
      this.enableManageReservation = false;
      this.$refs.PCSeleccionLineasPedidoVenta?.ClearElementSelected();
      this.newDataTransfer = [];
    },

    /**
     * Handles the selection of an option in the side navbar.
     * @param {SideNavbarItem} item - The selected option.
     */
    OpcionSideNavbarSeleccionada(item) {
      Log(this, this.OpcionSideNavbarSeleccionada.name);

      if (item.key === 'more') {
        this.popupConfiguracionPicking = true;
      }
    },

    ActivarLecturaDeCajas(value) {
      Log(this, this.ActivarLecturaDeCajas.name);
      this.activarLecturaDeCajas = value;
    },
  },
};
</script>

<style scoped lang="scss">
.page-picking {
  // TODO: Remove when migrated to new styles
  --f7-button-padding-horizontal: 10px;
  --f7-button-height: 44px;
  --search-input-bg-color: var(--his-tierra-white);
  --search-btn-border-left: 0;
  //

  --information-bar-padding-bottom: 0;
}

.content-picking {
  background-color: #f7f7f7;

  &__pedido {
    --f7-button-text-transform: none;

    background: #ebecf0;
    display: flex;

    &--grid {
      width: 270px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 8px;
      margin-left: 8px;
      margin-top: 10px;
    }
  }

  &__right-side {
    height: 100vh;
    overflow: scroll;
  }
}

.content-grid {
  display: grid;
  row-gap: 2vh;
  grid-template-columns: 0.8fr 2fr 1.2fr;
  column-gap: 1vw;
}

.content-grid > div:nth-child(1) {
  grid-column: span 1;
}

.content-grid > div:nth-child(2) {
  grid-column: span 1;
  grid-row: 2 span;
}

.main-picking,
.panel {
  .badge {
    height: 22px;
    width: 22px;
    font-size: 15px;
    background: #e4e4e4;
    color: var(--his-metal);
    font-weight: 500;
  }

  .card {
    margin: 0;

    .card-header {
      background-color: #ebecf0;
      text-transform: uppercase;
    }
  }

  .content-list-checkbox-item,
  .content-title-select {
    padding: 7px 15px;
    background: #f4f5f7;
    margin-bottom: 2px;
    border: 1px solid #ebebed;
    border-radius: 3px;

    &.incidence {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #ff5630;
    }

    &.out-of-line {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #fcff30;
    }
  }

  .content-list-checkbox-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > div {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    label {
      margin-right: 10px;
    }

    &__details {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 16px;

      &--title {
        color: var(--his-dark-blue);
      }

      &--subtitle {
        color: var(--his-kiwi-pulp);
        text-transform: uppercase;
      }

      img {
        border-radius: 50%;
        margin: 0 10px 0 0;
        width: 64px;
        height: 64px;
      }

      &--total {
        display: flex;

        img {
          height: 20px;
          width: 20px;
          margin: 0;
          padding: 0 0 0 5px !important;
          border-radius: 0;
        }
      }
    }

    &__time {
      color: var(--his-slate-blue);
      font-size: 28px;
      display: flex;
      align-items: center;

      &::after {
        font-family: "framework7-core-icons";
        font-weight: normal;
        direction: ltr;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        -moz-font-feature-settings: "liga";
        font-feature-settings: "liga";
        text-align: center;
        display: block;
        margin-left: 15px;
        font-size: var(--f7-list-chevron-icon-font-size);
        color: var(--f7-list-chevron-icon-color);
        pointer-events: none;
        right:
          calc(
            var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-right)
          );
        content: var(--f7-list-chevron-icon-right);
      }
    }

    &.checked {
      background-color: var(--his-steel-blue);
      color: #fff;

      .badge {
        background-color: #253858;
        color: #fff;
      }
    }
  }

  .content-title-select {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__input {
      display: flex;
      align-items: center;
      color: var(--his-steel-blue);
      font-weight: 500;
      font-size: 15px;
      text-transform: uppercase;

      label {
        margin-right: 12px;
      }
    }
  }

  .content-new-activity {
    &__datetime {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > div {
        width: 100%;
      }

      > div:first-child {
        margin-right: 15px;
      }

      > div:nth-child(2) {
        max-width: 120px !important;
      }

      input {
        color: var(--his-dark-blue);
        font-weight: 500;
        font-size: 16px;
      }
    }
  }

  label.item-checkbox input[type="checkbox"]:checked ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:checked ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:checked ~ i,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:indeterminate ~ i {
    background-color: #566784;
    border-color: #566784;
    zoom: 1.3;
  }

  .icon-checkbox {
    zoom: 1.3;
  }

  .actions-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

a.panel-close {
  background: var(--his-dark-blue);
  display: flex;
}

.ios .icon-checkbox,
.ios .checkbox i {
  zoom: 1.1 !important;
}

@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr 2fr;
  }

  .content-logo-hispatec {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr 3fr !important;
  }
}

@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 530px) {
  .content-logo-company {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr !important;
  }

  .content-list-checkbox-item__details {
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .content-list-checkbox-item__time {
    font-size: 18px !important;
    font-weight: 600;
    padding-left: 10px;
  }

  .content-list-checkbox-item__details img.avatar-round {
    width: 48px !important;
    height: 48px !important;
  }
}

.span-text-error {
  color: red;
  font-size: 11px;
  opacity: 0.7;
}

.content-list-checkbox-scroll {
  height: 72vh;
  overflow-y: auto;
}

.campo_New {
  margin-bottom: 10px;
  background: var(--his-bg);
  border: 1px solid rgb(212 212 212 / 29.9%);
  box-sizing: border-box;
  border-radius: 6px;
  list-style-type: none;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.campo_Cantidad-input {
  background: var(--his-tierra-white);
  border: 0.78125px solid var(--his-silver);
  border-radius: 6.25px;
  margin-left: 10px !important;
  margin-right: 10px !important;
  margin-top: 6px;
}

.campo_Fecha-input {
  margin-right: 5px !important;
  margin-left: 10px !important;
  padding: 0 !important;
}

.campo_Hora-input {
  margin-right: 10px !important;
  margin-left: 5px !important;
  padding: 0 !important;
}

.style_Text_Outline {
  font-weight: 700;
  font-size: 14px;
  color: var(--his-steel-blue);
}

.style_Text_Outline2-3 {
  font-weight: 400;
  font-size: 14px;
  color: var(--his-steel-blue);
}

.content_card {
  background: #ebecf0;
  padding-left: 0;
  padding-right: 0;
}

.style_Title1 {
  left: 10.85%;
  right: 70.93%;
  top: 24.29%;
  bottom: 42.86%;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: var(--his-steel-blue);
}

.style_Title2 {
  left: 40.44%;
  right: 48.06%;
  top: 15.71%;
  bottom: 58.57%;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--his-oliva);
}

.content_Field1 {
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: var(--his-oliva);
}

.content_Field2-3 {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: var(--his-steel-blue);
}

.background_icon_Imprimir {
  left: 2.33%;
  right: 91.47%;
  top: 17.14%;
  bottom: 14.29%;
  background: var(--his-steel-blue);
}

.button1 {
  width: 209px;
  background: var(--his-mandarina);
  border-radius: 6px;
  margin-left: 10px;
}

.style_Text1 {
  position: static;
  font-weight: 500;
  letter-spacing: 0.85px;
  color: #fff;
}

.button2 {
  width: 209px;
  border: 1px solid;
  border-color: var(--his-metal);
  background: #ebecf0;
}

.style_Text2 {
  position: static;
  font-weight: 500;
  letter-spacing: 0.85px;
  color: var(--his-metal);
}

.button3 {
  margin-left: 100px;
  background: var(--his-greendark);
  border-radius: 6px;
  margin-right: 10px;
}

.style_Text3 {
  position: static;
  font-weight: 500;
  letter-spacing: 0.85px;
  color: #fff;
}

.menu {
  background-color: #ebecf0;
  box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
  width: 80px;
  height: 100vh;
  float: left;
}

.disabled-component {
  opacity: 0.6;
  pointer-events: none;
}
</style>
